<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3>
            <i class="fas fa-map-marked-alt"></i> Módulo de Visitas
            <small style="font-size: 18px">| Registrar Deslocamento</small>
          </h3>
          <small>Acompanhe, planeje e registre suas visitas.</small>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <Forms
            ref="frmGroup"
            :title="'REGISTRAR PONTO INICIAL'"
            :showClearButton="true"
            :showSaveButton="true"
            :showBackButton="true"
            v-on:Clear="onClear"
            v-on:Back="onBack"
            v-on:Save="onSave"
          >
            <div class="form-group row pt-2">
              <div
                v-if="hasHodometroVisitas()"
                class="col-md-4 pb-2"
              >
                <label for="txtName">
                  <small class="text-danger">*</small> Hodometro Inicial:
                </label>
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fas fa-road"> </i
                  ></span>
                  <b-form-input
                    type="number"
                    min="0"
                    :placeholder="'Digite o Km Inicial'"
                    v-model="data.hodometroInicial"
                    :required="true"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-12">
                <label><small class="text-danger">*</small> Local:</label>
                <div
                  class="input-group"
                  style="border: solid 1px #d6d6d6"
                >
                  <Map
                    ref="map"
                    style="width: 100%; height: 400px"
                    @initialized="onInitialized"
                    @change:location="handleCoords"
                  />
                </div>
              </div>
            </div>
          </Forms>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img
            src="/static/img/bg/world_re_768g.svg"
            style="width: 40%; opacity: 0.2"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import VisitasConfig from '@/shared/mixins/visitasConfig'
import { loading, toast } from '@/shared/utils/UIHelper'

import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'

import Map from '../../components/Map.vue'

const data = {
  coordsTempoReal: null,
  latitudeInicial: null,
  longitudeInicial: null,
  hodometroInicial: null
}

export default {
  name: 'PontoInicial',
  mixins: [ActionsForm, VisitasConfig],
  components: {
    Map
  },
  data () {
    return {
      data: data
    }
  },
  mounted () {
    loading.push()
    Tools.MinimizedSidebar()
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    onInitialized () {
      loading.pop()
    },
    async handleCoords () {
      const currentCoords = await this.$refs.map.getCurrentLocation()

      this.data.coordsTempoReal = this.data.coordsTempoReal === null
      this.data.latitudeInicial = currentCoords.latitude
      this.data.longitudeInicial = currentCoords.longitude
    },
    async onCreate () {
      if (this.$refs.map.enableSearch && !this.$refs.map.search.trim()) {
        toast.error('Você precisa digitar um endereço pois selecionou Localização Manual.')
        return
      }

      if (this.data.latitudeInicial === null) {
        toast.warning('Geolocalização é necessária para iniciar o deslocamento')
        return
      }
      if (this.hasHodometroVisitas() && this.data.hodometroInicial === null) {
        toast.warning('Informe o hodometro inicial para iniciar o deslocamento')
        return
      }

      try {
        loading.push()
        await DeslocamentoRepository.StartDeslocamento(this.data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.onBack()
      } catch (error) {
        toast.error(this.$lang.Common.Alerts.Error)
      } finally {
        loading.pop()
      }
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.25rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/pontos/pontoinicial.vue